// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminBtnBaseDropZoneContainer .filepicker {
    background-color: transparent;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-family-base);
    font-size: 18px;
    font-weight: 500;
    color: var(--common-text-color);
    padding: 12px 19px;
    border: 1px solid var(--border-secondary-color);
    border-radius: 6px;
    text-align: center;
}

.adminBtnBaseDropZoneContainer .filepicker .dz-message {
    display: none;
}

.adminBtnBaseDropZoneContainer {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.adminBtnBaseDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

.adminBtnBaseDropZoneSubText {
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
    color: var(--common-text-color);
    margin-bottom: 10px;
}

/* Home Banner Setting start */

.adminBoxBaseDropZoneContainer {
    margin-bottom: 30px;
    cursor: pointer;
    text-align: center;
    background: var(--common-gray-bg-color);
    border-radius: 12px;
}

.adminBoxBaseDropZoneContainer .filepicker {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 22px;
    min-height: 300px;
    font-family: var(--font-family-base);
    background-color: transparent;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23D9DDE3FF' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 12px;
    padding: 20px;
    border: none;
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
}

.adminBoxBaseDropZoneContainer .filepicker .dz-message {
    display: none;
}

.adminBoxBaseDropZoneIcon {
    position: relative;
    width: 66px;
    height: 60px;
    z-index: -1;
}

.adminBoxBaseDropZonePlaceholder {
    position: relative;
    z-index: -1;
}

.adminBoxBaseDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZonePlaceholder,
.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZoneIcon {
    display: none;
}

.adminBoxBaseDropZoneContainer .dz-preview.dz-image-preview {
    background: transparent;
}

.adminBoxBaseDropZoneContainer .dz-preview .dz-details .dz-filename:hover {
    overflow: hidden;
    text-overflow: ellipsis;
}

.adminBoxBaseDropZoneContainer .filepicker.dz-started {
    flex-direction: row;
    flex-wrap: wrap;
}

.adminBoxBaseDropZoneContainer .dropzone .dz-preview.dz-error .dz-error-message {
    display: none !important;
}

/* Home Banner Setting end */`, "",{"version":3,"sources":["webpack://./src/styles/adminDropzone.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,kBAAkB;IAClB,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,8BAA8B;;AAE9B;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,6BAA6B;IAC7B,qTAAqT;IACrT,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,4BAA4B","sourcesContent":[".adminBtnBaseDropZoneContainer .filepicker {\n    background-color: transparent;\n    min-height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: var(--font-family-base);\n    font-size: 18px;\n    font-weight: 500;\n    color: var(--common-text-color);\n    padding: 12px 19px;\n    border: 1px solid var(--border-secondary-color);\n    border-radius: 6px;\n    text-align: center;\n}\n\n.adminBtnBaseDropZoneContainer .filepicker .dz-message {\n    display: none;\n}\n\n.adminBtnBaseDropZoneContainer {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n}\n\n.adminBtnBaseDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n.adminBtnBaseDropZoneSubText {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: normal;\n    color: var(--common-text-color);\n    margin-bottom: 10px;\n}\n\n/* Home Banner Setting start */\n\n.adminBoxBaseDropZoneContainer {\n    margin-bottom: 30px;\n    cursor: pointer;\n    text-align: center;\n    background: var(--common-gray-bg-color);\n    border-radius: 12px;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    row-gap: 22px;\n    min-height: 300px;\n    font-family: var(--font-family-base);\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23D9DDE3FF' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\");\n    border-radius: 12px;\n    padding: 20px;\n    border: none;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker .dz-message {\n    display: none;\n}\n\n.adminBoxBaseDropZoneIcon {\n    position: relative;\n    width: 66px;\n    height: 60px;\n    z-index: -1;\n}\n\n.adminBoxBaseDropZonePlaceholder {\n    position: relative;\n    z-index: -1;\n}\n\n.adminBoxBaseDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZonePlaceholder,\n.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZoneIcon {\n    display: none;\n}\n\n.adminBoxBaseDropZoneContainer .dz-preview.dz-image-preview {\n    background: transparent;\n}\n\n.adminBoxBaseDropZoneContainer .dz-preview .dz-details .dz-filename:hover {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker.dz-started {\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.adminBoxBaseDropZoneContainer .dropzone .dz-preview.dz-error .dz-error-message {\n    display: none !important;\n}\n\n/* Home Banner Setting end */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
